import { CircularProgress, Grid } from "@mui/material";
import PDialog from "./PDialog";

export default function PProgressDialog(props) {
  return (
    <PDialog
      content={
        <Grid container style={{ width: 200, margin: 20 }}>
          <Grid item xs={12}>
            <CircularProgress disableShrink /> {props.message}
          </Grid>
        </Grid>
      }
      maxWidth={"md"}
      fullWidth={false}
      open={true}
      borderLess={true}
    ></PDialog>
  );
}
